import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TemplateObjectsService } from '../template-process/services/template-objects.service';

@Component({
    selector: 'edit-template-dialog',
    templateUrl: 'edit-template-dialog.component.html',
    styleUrls: ['./edit-template-dialog.component.scss'],
})
export class EditTemplateDialog {
    private result: any = {};
    constructor(private documentTemplatesService: TemplateObjectsService,
        public dialogRef: MatDialogRef<EditTemplateDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        console.log(data);
    }

    onSaveMerged($event) {
        this.result.evaluated = $event;
    }
    onSaveTemplate($event) {
        this.result.template = $event;
    }
    onSaveAsPDF(data) {
        // this.documentTemplatesService.saveBase64DocAsPDF(data).subscribe(result => {
        //     this.saveBlobPDF(result);
        // }, error => {
        //     console.error(error);
        // }, () => {
        //     this.dialogRef.close();
        // });
    }
    onProcessFinish($event) {
        this.dialogRef.close(this.result);
    }

    private saveBlobPDF(blobData: any): void {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blobData);
        // a.style = 'display: none';
        a.href = objectUrl;
        a.download = (this.data.name || 'sample') + '.pdf';
        a.click();
        URL.revokeObjectURL(objectUrl);
    }

}
